module.exports = __webpack_public_path__ + "img/mapa.c0c41780.png";